/**
 * Locale-aware date formatting for the interaction UI.
 *
 * The app renders in Polish by default and in English under `/en`; the
 * i18next language (`pl` / `en`) picks the Intl locale.
 */

function toIntlLocale(lang: string | undefined): string {
  return lang?.toLowerCase().startsWith('en') ? 'en-GB' : 'pl-PL';
}

/** Numeric short date, e.g. `12.06.2026` (pl) / `12/06/2026` (en). */
export function formatDateShort(value: string, lang?: string): string {
  const d = new Date(value);
  return isNaN(d.getTime()) ? value : d.toLocaleDateString(toIntlLocale(lang));
}

/** Long date, e.g. `12 czerwca 2026` / `12 June 2026`, optionally with time. */
export function formatDate(
  value: string,
  lang?: string,
  options?: { includeTime?: boolean },
): string {
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;

  const locale = toIntlLocale(lang);
  const date = d.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  if (!options?.includeTime) return date;

  const time = d.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${date}, ${time}`;
}
